var _path, _ellipse, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFurniture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
    fill: "#BCD9C9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 33,
    rx: 18.5,
    ry: 20,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33,
    r: 20.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3808 42.3846V42.2346H24.2308H21.8077C21.4447 42.2346 21.15 41.9399 21.15 41.5769V23.8077C21.15 23.4447 21.4447 23.15 21.8077 23.15H41.1923C41.5553 23.15 41.85 23.4447 41.85 23.8077V41.5769C41.85 41.9399 41.5553 42.2346 41.1923 42.2346H38.7692H38.6192V42.3846V43.1923C38.6192 43.5553 38.3245 43.85 37.9615 43.85C37.5985 43.85 37.3038 43.5553 37.3038 43.1923V42.3846V42.2346H37.1538H25.8462H25.6962V42.3846V43.1923C25.6962 43.5553 25.4015 43.85 25.0385 43.85C24.6755 43.85 24.3808 43.5553 24.3808 43.1923V42.3846ZM40.3846 40.9192H40.5346V40.7692V24.6154V24.4654H40.3846H22.6154H22.4654V24.6154V40.7692V40.9192H22.6154H40.3846Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0385 30.1194H24.8885V30.2694V38.3464V38.4964H25.0385H37.9616H38.1116V38.3464V30.2694V30.1194H37.9616H25.0385ZM38.7692 39.8117H24.2308C23.8678 39.8117 23.5731 39.5171 23.5731 39.1541V29.4617C23.5731 29.0987 23.8678 28.8041 24.2308 28.8041H38.7692C39.1323 28.8041 39.4269 29.0987 39.4269 29.4617V39.1541C39.4269 39.5171 39.1323 39.8117 38.7692 39.8117Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0385 26.8884H24.2308C23.8678 26.8884 23.5731 26.5937 23.5731 26.2307C23.5731 25.8677 23.8678 25.573 24.2308 25.573H25.0385C25.4015 25.573 25.6962 25.8677 25.6962 26.2307C25.6962 26.5937 25.4015 26.8884 25.0385 26.8884Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2692 26.8884H27.4615C27.0985 26.8884 26.8038 26.5937 26.8038 26.2307C26.8038 25.8677 27.0985 25.573 27.4615 25.573H28.2692C28.6322 25.573 28.9269 25.8677 28.9269 26.2307C28.9269 26.5937 28.6322 26.8884 28.2692 26.8884Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4999 26.8884H30.6922C30.3292 26.8884 30.0345 26.5937 30.0345 26.2307C30.0345 25.8677 30.3292 25.573 30.6922 25.573H31.4999C31.8629 25.573 32.1576 25.8677 32.1576 26.2307C32.1576 26.5937 31.8629 26.8884 31.4999 26.8884Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7692 26.8884H37.9615C37.5985 26.8884 37.3038 26.5937 37.3038 26.2307C37.3038 25.8677 37.5985 25.573 37.9615 25.573H38.7692C39.1322 25.573 39.4269 25.8677 39.4269 26.2307C39.4269 26.5937 39.1322 26.8884 38.7692 26.8884Z",
    fill: "#EE8322",
    stroke: "white",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFurniture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-furniture.0bd0a3d0d6d550b08520341524a5efe3.svg";